import type { Product } from "../../app/types.js";

// How much of a food is on hand, in words. Extracted (#1058) because the answer
// now has to read the same on the Food grid, the Food dashboard and a shopping
// list row — the whole point of showing stock while building a list is that it
// agrees with what Food says.
//
// The server aggregates open lots per unit, so a food bought as both "2 gal" and
// "1 qt" legitimately has two entries and neither can be summed into the other.
// Zero-quantity entries are dropped rather than rendered as "0 gal": an empty
// answer means "nothing on hand", and every caller words that itself.

export function onHandEntries(product?: Product | null): Array<{ quantity: number; unit: string }> {
  return (product?.onHand ?? []).filter((entry) => entry.quantity > 0);
}

export function onHandLabel(product?: Product | null): string {
  return onHandEntries(product)
    .map((entry) => `${entry.quantity} ${entry.unit}`.trim())
    .join(", ");
}

export function hasStockOnHand(product?: Product | null): boolean {
  return onHandEntries(product).length > 0;
}
